import { render, staticRenderFns } from "./dui-video-player.vue?vue&type=template&id=8fce4ef8&"
import script from "./dui-video-player.vue?vue&type=script&lang=js&"
export * from "./dui-video-player.vue?vue&type=script&lang=js&"
import style0 from "./dui-video-player.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports